export const DATA = {
  STRUGGLE_WITH_WEIGHT_LOSS: "I gain weight fast but lose it slowly",
  EASY_WEIGHT_GAIN_AND_LOSS: "I gain and lose weight easily",
  STRUGGLE_WITH_WEIGHT_GAIN: "I struggle to gain weight or muscle",
};
